/**
 * RUIN art direction: a cold institutional signal-feed running a lethal game
 * show. Deep blue-black substrate, phosphor signal-green broadcast overlay,
 * warm hostile assets, one violet outlier (the Auditor).
 *
 * DECISION: palette derived from the compliance-broadcast fiction (CRT
 * phosphor green + institutional slate + hazard amber), explicitly avoiding
 * the generic cream/terracotta and black+acid-accent defaults.
 */
export const PALETTE = {
  void: '#04060a',
  floor: '#10151c',
  floorLine: '#161d26',
  wall: '#232c38',
  wallTop: '#2e3946',
  wallEdge: '#0b0e13',
  rubble: '#1a212b',
  door: '#7a5a2e',
  doorLocked: '#b08a3e',
  exit: '#57e6a8',
  trap: '#8a3038',
  teleporter: '#41e0ff',
  relay: '#ffd24a',

  signal: '#57e6a8', // broadcast/feed green
  signalDim: '#2e7d5f',
  alertAmber: '#ffb454',
  alarmRed: '#ff4f5e',

  participant: '#e8f4ff',
  participantAccent: '#52d8ff',

  hostile: '#ff6a3d',
  husk: '#ff6a3d',
  sentry: '#e0483f',
  static: '#9fb4c8',
  foreman: '#ffa02e',
  auditor: '#8a4dff',
  auditorBody: '#241238',

  generatorCore: '#ff8a4d',

  food: '#4ade80',
  key: '#ffd23f',
  magic: '#41e0ff',
  treasure: '#ffe9a3',
  archive: '#cfe0ee',

  projPlayer: '#bfeaff',
  projEnemy: '#ff9d4d',

  enemyBurst: {
    husk: '#ff6a3d',
    sentry: '#e0483f',
    static: '#9fb4c8',
    foreman: '#ffa02e',
    auditor: '#8a4dff'
  } as Record<string, string>
} as const
